module.exports = __webpack_public_path__ + "img/lc-range.5816c9f0.png";